import { Badge, Progress } from "../../fusion";
import { useResource } from "../contexts/ResourceContext";

// If filesOverride is provided, the file display will use the deleteOverride function passed in.
const FileDisplay = ({ filesOverride = null, deleteOverride }) => {
  const { files, deleteChatResource } = useResource();

  const displayFiles = Array.isArray(filesOverride) ? filesOverride : Array.isArray(files) ? files : [];

  return (
    <>
      <table className="o-treegrid o-treegrid--compact l-mr-sm">
        <colgroup className="o-treegrid__colgroup">
          <col className="o-treegrid__col o-treegrid__col--fill" span="1" />
          <col className="o-treegrid__col o-treegrid__col--x-small" span="1" />
        </colgroup>
        <tbody>
          {displayFiles.length === 0 ? (
            <tr>
              <td colSpan="2" className="o-treegrid__cell">No files selected.</td>
            </tr>
          ) : (
            displayFiles.map((file, index) => (
              <tr
                className="o-treegrid__row o-treegrid__row--shown"
                key={`${file.resourceName}-${index}`}
              >
                <td className="o-treegrid__cell">
                  <span className="a-subtle-text">
                    <strong>{file.resourceName}</strong>
                  </span>
                  {file?.pendingUpload && (
                    <span style={{ marginLeft: "20px" }}>
                      <Badge hue="primary-500" value="New" />
                    </span>
                  )}
                </td>
                <td className="o-treegrid__cell o-treegrid__cell--right-aligned">
                  {!filesOverride && file.uploading ? (
                    <Progress inLine="true">Uploading</Progress>
                  ) : (
                    <button
                      className="a-button a-button--outline a-button--small"
                      onClick={(e) => {
                        e.preventDefault();
                        filesOverride ? deleteOverride(index) : deleteChatResource(file);
                      }}
                    >
                      Remove
                    </button>
                  )}
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </>
  );
};

export default FileDisplay;
